<template>
  <div>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ $t('Мои организации') }}</h1>
      <div class="search-pg workroom-pg">
        <div class="my-organization">
          <div class="bgw-pdg-20">
            <div class="search-head">
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-label>{{ $t('Поиск по названию') }}</v-label>
                  <v-text-field
                    :placeholder="$t('Введите текст')"
                    v-model="search.name"
                    required
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-label>{{ $t('Организации') }}</v-label>
                  <div class="select-def">
                    <v-select
                      :items="refType"
                      item-value="id"
                      item-text="transName"
                      v-model="search.type"
                      :placeholder="$t('Все')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="search.type === ooptType">
                  <v-label>{{ $t('Тип ООПТ') }}</v-label>
                  <div class="select-def">
                    <v-select
                      :items="refCategory"
                      item-value="id"
                      item-text="transName"
                      v-model="search.category"
                      :placeholder="$t('Все')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="search.type === huntingFarmType">
                  <v-label>{{ $t('Отчетность и БСО') }}</v-label>
                  <div class="select-def">
                    <v-select
                      :items="refDepartmentOopt"
                      item-value="id"
                      item-text="transName"
                      v-model="search.ooptReportingBso"
                      :placeholder="$t('Все')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </v-col>
              </v-row>
              <div class="search-action">
                <button
                  class="btn btn-default green-grassy"
                  @click="searchOOPT(true)"
                >
                  {{ $t('Поиск') }}
                </button>
                <button
                  class="btn btn-default gray"
                  @click="clearForm"
                >
                  {{ $t('Очистить') }}
                </button>
              </div>
            </div>
            <div class="search-body">
              <div class="table-overflow">
                <table class="table-full">
                  <thead>
                  <tr>
                    <td>{{ $t('Наименование') }}</td>
                    <td>{{ $t('Тип') }}</td>
                    <td>
                      <div class="sort-flex">
                        {{ $t('Статус') }}
                        <a @click="sort('status')" class="sort-btn sort-blue">
                          <v-icon v-if="sortParams.field == 'status' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                          <v-icon v-else>arrow_drop_down</v-icon>
                        </a>
                      </div>
                    </td>
                    <td>
                      <div class="sort-flex">
                        {{ $t('Последнее изменение') }}
                        <a @click="sort('lastChange')" class="sort-btn sort-blue">
                          <v-icon v-if="sortParams.field == 'lastChange' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                          <v-icon v-else>arrow_drop_down</v-icon>
                        </a>
                      </div>
                    </td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="oopt in data" :key="oopt.id">
                    <td>
                      <v-list>
                        <v-list-group no-action :value="$route.query.id && $route.query.id == oopt.id">
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title v-text="oopt.name"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <v-list-item
                            v-for="link in links[oopt.type.id]" :to="{ name: link.routeName, params: { id: oopt.id } }"
                            :key="link.label"
                          >
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ $t(link.label) }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>
                      </v-list>
                      <router-link
                        v-if="oopt.status.id === oopt.publicStatus"
                        :to="{ name: oopt.type.id === oopt.typeIdConst ? 'View' : 'View-Organization',
                        params: { id: oopt.id } }"
                        target="_blank"
                        class="btn-collapse"
                      >
                        <img src="@/assets/img/collapse-icon.png" alt="icon">
                      </router-link>
                    </td>
                    <td>{{ oopt.type.transName }}</td>
                    <td>
                      <div class="status-org">
                        <ul>
                          <li class="active" :class="{ publish: oopt.status.id !== 2 }">
                            <a href="#">{{ oopt.status.transName }}</a>
                          </li>
                          <li v-if="oopt.status.id === 1 && isAdmin === true">
                            <a @click="publicOopt(oopt, 2)">{{ $t('Снять с публикации') }}</a>
                          </li>
                          <li v-if="oopt.status.id === 2">
                            <a @click="publicOopt(oopt, 1)">{{ $t('Опубликовать') }}</a>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <template v-if="oopt.lastChange">
                        {{ new Date(oopt.lastChange.date) | dateFormat('DD.MM.YYYY HH:mm') }} {{ oopt.lastChange.user }}
                      </template>

                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="search-result-footer">
                  <p>{{ $t('Всего найдено') }}: {{ this.paginationData.totalCount }}</p>
                </div>
              </div>
              <v-pagination
                v-model="page"
                :length="paginationData.pageCount"
                total-visible="10"
              />
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Oopt from '@/model/oopt'

export default {
  data: () => ({
    breadcrumbs: [],
    search: {},
    page: 1,
    paginationData: {},
    data: [],
    refCategory: [],
    refType: [],
    refDepartmentOopt: [],
    links: [],
    ooptType: null,
    huntingFarmType: null,
    target: '',
    isAdmin: false,
    sortParams: {
      field: 'id',
      order: 'DESC'
    }
  }),
  watch: {
    $route: 'fetchData',
    page () {
      this.searchOOPT()
    }
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Oopt.searchFormData().then((response) => {
        this.refCategory = response.data.refCategory
        this.refType = response.data.refType
        this.refDepartmentOopt = response.data.refDepartmentOopt
        this.ooptType = response.data.ooptType
        this.huntingFarmType = response.data.huntingFarmType
        this.links = response.data.links
        this.isAdmin = response.data.isAdmin
        this.setSearchFromLocalStorage()
        this.searchOOPT()
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.generateBreadcrumbs()
      this.setLoading(false)
    },
    searchOOPT (resetPage = false) {
      this.setLoading(true)
      if (resetPage) {
        this.page = 1
      }
      this.search.page = this.page
      if (this.search.type !== this.ooptType) {
        this.search.category = null
      }
      if (this.search.type !== this.huntingFarmType) {
        this.search.ooptReportingBso = null
      }
      if (this.$route.query.id) this.search.id = this.$route.query.id
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      this.setLocalStorageFromSearch()

      Oopt.getMyOopt(this.search).then((response) => {
        this.data = response.data.items
        this.paginationData = response.data.paginationData
        this.setLoading(false)
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    setSearchFromLocalStorage () {
      if (localStorage.getItem('searchName') !== null && localStorage.getItem('searchName') !== 'undefined') {
        this.search.name = localStorage.getItem('searchName')
      }
      if (localStorage.getItem('searchType') !== null && !isNaN(parseInt(localStorage.getItem('searchType')))) {
        this.search.type = parseInt(localStorage.getItem('searchType'))
      }
      if (localStorage.getItem('searchCategory') !== null && !isNaN(parseInt(localStorage.getItem('searchCategory')))) {
        this.search.category = parseInt(localStorage.getItem('searchCategory'))
      }
      if (localStorage.getItem('searchOoptReportingBso') !== null && !isNaN(parseInt(localStorage.getItem('searchOoptReportingBso')))) {
        this.search.ooptReportingBso = parseInt(localStorage.getItem('searchOoptReportingBso'))
      }
      this.page = 1
      if (localStorage.getItem('searchPage') !== null && !isNaN(parseInt(localStorage.getItem('searchPage')))) {
        this.page = parseInt(localStorage.getItem('searchPage'))
      }
    },
    setLocalStorageFromSearch () {
      localStorage.setItem('searchName', this.search.name)
      localStorage.setItem('searchType', this.search.type)
      localStorage.setItem('searchCategory', this.search.category)
      localStorage.setItem('searchOoptReportingBso', this.search.ooptReportingBso)
      // localStorage.setItem('searchSortField', this.search.sortField)
      // localStorage.setItem('searchSortOrder', this.search.sortOrder)
      localStorage.setItem('searchPage', this.search.page)
    },
    removeLocalStorage () {
      localStorage.removeItem('searchName')
      localStorage.removeItem('searchType')
      localStorage.removeItem('searchCategory')
      localStorage.removeItem('searchOoptReportingBso')
      localStorage.removeItem('searchPage')
    },
    publicOopt (oopt, status) {
      this.setLoading(true)

      Oopt.publicOopt(oopt.id, status).then((response) => {
        oopt.status = response.data
        this.setLoading(false)
      })
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.searchOOPT(true)
    },
    clearForm () {
      this.search = {}
      this.sortParams = {
        field: 'id',
        order: 'DESC'
      }
      this.removeLocalStorage()
      this.$router.replace({ query: null })
      this.searchOOPT(true)
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Мои организации'),
          disabled: true
        }
      ]
    }
  }
}
</script>
